export const PAGE_LIMIT = 100;

export const PARAMS_NAME = {
    invalidImpressions: 'Invalid Impressions',
    partnerCost: 'Partner Cost',
    roi: 'ROI',
    roiPercent: 'ROI %',
    wonPercent: 'WON %',
    eCPM: 'eCPM',
    responseECPM: 'Response eCPM',
    fillRate: 'Fill Rate',
    realCost: 'Real Cost'
};

export const NAN_PARAMS = {
    date: 1,
    hour: 1,
    affid: 1,
    subid: 1,
    country: 1
};



// WEBPACK FOOTER //
// ./src/scenes/AdkDailyV3/config.js